const CONTENT_AREA_KEY = 'content_area_collapsible'
const PRICING_AREA_KEY = 'pricing_collapsible'
const ADDITIONAL_SERVICES_KEY = 'additional_services_collapsible'

/**
 * Get true/false values for different collapsible fields of Event
 * Keys may or may not exist in old data, so add falsy-defaults
 */
export const getCollapsibleOptions = (fields) => {
  const collapsibles = {
    content: false,
    pricing: false,
    additionalServices: false,
  }

  if (fields[CONTENT_AREA_KEY]) {
    collapsibles.content = fields[CONTENT_AREA_KEY]
  }

  if (fields[PRICING_AREA_KEY]) {
    collapsibles.pricing = fields[PRICING_AREA_KEY]
  }

  if (fields[ADDITIONAL_SERVICES_KEY]) {
    collapsibles.additionalServices = fields[ADDITIONAL_SERVICES_KEY]
  }

  return collapsibles
}

export default {
  getCollapsibleOptions,
}
